import './image-flag.scss'

export const ImageFlag = ({
  index,
  imageContent,
  imageWidth,
  imageHeight,
  imageAlt,
}: any) => {
  return (
    <img
      className={`image-flag${index === 0 ? ' first-flag' : ' second-flag'}`}
      src={imageContent}
      alt={imageAlt}
      width={imageWidth}
      height={imageHeight}
    />
  )
}
